import axios from "axios";
import useTelemetryStore from '@/store/telemetry'


export const sendRegistryEvent = async (latitude, longitude, altitude, extra) => {
    const url  = "https://breg.cvis.videri.ai/registry/go_to_point/create";
    const header = {
        "x-auth-token": localStorage.getItem("x-auth-token")
    }
    const payload = {
        "user_id": localStorage.getItem("user_id"),
        "username": localStorage.getItem("username"),
        "ts": Date.now(),
        "latitude": latitude,
        "longitude": longitude,
        "type": "arauco",
        "altitude": altitude,
        "dock_sn": localStorage.getItem("device_sn"),
        "drone_sn": localStorage.getItem("child_device_sn"),
        "extra": extra,
    }
    console.warn(payload)
    try {
        const result = await axios.post(url, payload, { headers: header });
        return result;
    } catch {
        return null;
    }
}


export const sendScreenshotEvent = async (image) => {
    const store = useTelemetryStore();
    /* eslint-disable */ 
    const drone_sn = localStorage.getItem("child_device_sn");
    let altitude = 0;
    let latitude = 0;
    let longitude = 0;
    try {
        altitude = store.getDeviceTelemetry(drone_sn, "altitude")
        altitude = altitude.value;
        latitude = store.getDeviceTelemetry(drone_sn, "latitude")
        latitude = latitude.value;
        longitude = store.getDeviceTelemetry(drone_sn, "longitude")        
        longitude = longitude.value;
    } catch {
        altitude = 0
        latitude = 0
        longitude = 0
    }
    if (latitude == null) {
        latitude = 0
        longitude = 0
        altitude = 0
    }
    const url  = "https://breg.cvis.videri.ai/registry/screenshot/create";
    const header = {
        "x-auth-token": localStorage.getItem("x-auth-token")
    }
    const payload = {
        "user_id": localStorage.getItem("user_id"),
        "username": localStorage.getItem("username"),
        "ts": Date.now(),
        "image_base64": image,
        "dock_sn": localStorage.getItem("device_sn"),
        "drone_sn": localStorage.getItem("child_device_sn"),
        "latitude": latitude,
        "longitude": longitude,
        "altitude": altitude,
        "workspace_id": localStorage.getItem("workspace_id"),
    }
    console.warn(payload);
    try {
        const result = await axios.post(url, payload, { headers: header });
        return result;
    } catch {
        return null
    }
}